import React from "react";
import { useNavigate } from "react-router-dom";
import { FLEET } from "../lib/api";
import { Users, Briefcase } from "lucide-react";

export default function Fleet() {
  const navigate = useNavigate();
  return (
    <div className="section-container py-16 sm:py-24">
      <div className="max-w-2xl">
        <div className="eyebrow mb-3">Curated Fleet</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-white leading-tight">Choose your class of comfort.</h1>
        <p className="mt-6 text-slate-400 leading-relaxed">Every vehicle in our fleet is meticulously maintained and professionally detailed. Reserve by class — request a specific vehicle in the reservation notes and we'll accommodate whenever available.</p>
      </div>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {FLEET.map((v) => (
          <div key={v.id} className="lume-card overflow-hidden group flex flex-col" data-testid={`fleet-card-${v.id}`}>
            <div className="aspect-[4/3] overflow-hidden">
              <img src={v.image} alt={v.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"/>
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <div className="font-serif text-xl text-white">{v.name}</div>
              <div className="flex items-center gap-4 mt-3 text-sm text-slate-300">
                <span className="flex items-center gap-1.5"><Users size={14} className="text-[color:var(--lume-gold)]"/>{v.capacity} Pax</span>
                <span className="flex items-center gap-1.5"><Briefcase size={14} className="text-[color:var(--lume-gold)]"/>{v.luggage} Bags</span>
              </div>
              <p className="text-sm text-slate-400 mt-4 italic">"{v.tagline}"</p>
              <div className="eyebrow mt-5 mb-2">Comfort Package</div>
              <ul className="space-y-1.5">
                {v.amenities.map((a) => (
                  <li key={a} className="text-xs text-slate-400 flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-[color:var(--lume-gold)]"/>{a}
                  </li>
                ))}
              </ul>
              {v.extra_note && <p className="mt-4 text-xs text-amber-300/80">{v.extra_note}</p>}
              <div className="flex-1"/>
              {v.quote_only
                ? <button onClick={() => navigate(`/contact?subject=quote&vehicle=${v.id}`)} className="mt-6 btn-outline-gold w-full" data-testid={`fleet-request-${v.id}`}>Request a Quote</button>
                : <button onClick={() => navigate(`/booking?vehicle=${v.id}`)} className="mt-6 btn-outline-gold w-full" data-testid={`fleet-request-${v.id}`}>Request This Class</button>
              }
            </div>
          </div>
        ))}
      </div>

      <div className="mt-14 lume-card p-8">
        <div className="eyebrow mb-2">Need a specific vehicle?</div>
        <p className="text-slate-300">Specific vehicle requests can be added to your reservation notes and will be accommodated when available.</p>
      </div>
    </div>
  );
}
